import apiService from './api.service'
import { extend, compact } from 'underscore'

export default class BaseApiService {
  constructor(url) {
    this.url = url
  }

  encodeQueryData(data) {
    const ret = []
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
    return ret.join('&')
  }

  getUrlWithParams(url, parameters) {
    var querystring = this.encodeQueryData(parameters)
    // if (!url.endsWith('/')) {
    //   url += '/'
    // }
    return `${url}?${querystring}`
  }

  getAbsoluteUrl(url = this.url) {
    return `${this.getBaseApi()}${url}`
  }

  getBaseApi() {
    return window.websiteConfig.apiUrl
  }

  composeUrl(...parts) {
    const urlSeparator = '/'
    parts = compact(parts)
    parts = parts.map(p => p.toString())
    const res = parts
      .filter(p => p.length > 0)
      .map(p => {
        if (p.charAt(0) === urlSeparator) p = p.substr(1)
        if (p.charAt(p.length - 1) === urlSeparator)
          p = p.substr(0, p.length - 1)
        return p
      })
      .join(urlSeparator)

    return res
  }

  // callDownload(u, q, fileName, extension, isUrlSpecified = false, a) {
  //   const fileNameWithExtension = `${fileName}.${extension}`
  //   const downloadUrl = isUrlSpecified ? u : this.composeUrl(this.url, u)
  //   return apiService(extend({
  //     url: downloadUrl,
  //     method: 'get',
  //     params: q,
  //     responseType: 'blob',
  //   }, a)).then(res => {
  //     const url = window.URL.createObjectURL(new Blob([res.data]))
  //     const link = document.createElement('a')
  //     link.href = url
  //     link.setAttribute('download', fileNameWithExtension) // HACK: ugly trick to save the file with a name
  //     document.body.appendChild(link)
  //     link.click()
  //   })
  // }

  callGet(u, q, a) {
    return apiService(
      extend(
        {
          url: this.composeUrl(this.url, u),
          method: 'get',
          params: q,
        },
        a
      )
    )
  }

  callPost(u, m, a) {
    return apiService(
      extend(
        {
          url: this.composeUrl(this.url, u),
          method: 'post',
          data: m,
        },
        a
      )
    )
  }

  callPut(u, m) {
    return apiService({
      url: this.composeUrl(this.url, u),
      method: 'put',
      data: m,
    })
  }

  callPatch(u, m) {
    return apiService({
      url: this.composeUrl(this.url, u),
      method: 'patch',
      data: m,
    })
  }

  callDelete(u, m) {
    return apiService({
      url: !m
        ? this.composeUrl(this.url, u)
        : this.composeUrl(this.url, u, m.id),
      method: 'delete',
    })
  }

  getLastModifiedTimestamp() {
    // TODO add backend function
    // return apiService.get(this.baseUrl, + url + '/get-last-modified-timestamp');
    return Promise.resolve(Date())
  }
}
